<script lang="ts">
    import type {Form} from 'typings/portaro.be.types';
    import type {Subscription} from 'rxjs';
    import type {FormGroup} from 'shared/value-editors/internal/forms/form-group';
    import {createEventDispatcher, onDestroy} from 'svelte';
    import {cleanup, exists} from 'shared/utils/custom-utils';
    import KpUniversalForm from 'shared/value-editors/kp-universal-form/KpUniversalForm.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import Spacer from 'shared/layouts/flex/Spacer.svelte';

    export let formSettings: Form;
    export let isFormSubmitting: boolean;

    const dispatch = createEventDispatcher<{
        'form-submit': Record<string, any>,
        'close': void
    }>();

    let universalForm: any;
    let fieldStateSubscription: Subscription;
    let formData: Record<string, any>; // Binding of model data from a universal form
    let isFormValid = false;

    $: if (exists(universalForm)) mountFormValidityCheck(universalForm?.getFormController());

    onDestroy(() => {
        cleanup(fieldStateSubscription);
    });

    function mountFormValidityCheck(formController: FormGroup<any>) {
        if (!exists(formController)) {
            return;
        }

        if (exists(fieldStateSubscription)) {
            fieldStateSubscription.unsubscribe();
        }

        fieldStateSubscription = formController.getFieldState$().subscribe((state) => isFormValid = state.valid);
    }

    const handleSubmitClick = () => {
        dispatch('form-submit', formData);
    };

    const handleCloseClick = () => {
        dispatch('close');
    };
</script>

<div class="action-buttons-container">
    <KpButton on:click={handleCloseClick}>
        <IconedContent icon="arrow-left">Zavřít</IconedContent>
    </KpButton>

    <Spacer flex="1"/>

    <KpButton isLoading={isFormSubmitting} isDisabled={!isFormValid} buttonStyle="primary" on:click={handleSubmitClick}>
        <IconedContent trailingIcon="arrow-right">Další</IconedContent>
    </KpButton>
</div>

<div class="generic-record-export-form-container">
    <span class="text-muted">
        Vyplňte povinná pole pro export
    </span>
    <Spacer direction="vertical" size="l"/>

    <KpUniversalForm bind:this={universalForm}
                     bind:model={formData}
                     {formSettings}/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro-erp.less";

    .action-buttons-container {
        display: flex;
        padding: @spacing-l @spacing-xxl;
        gap: @spacing-m;
        border-bottom: 1px solid @themed-border-default;
    }

    .generic-record-export-form-container {
        .flex-grow();
        padding: @spacing-l @spacing-xxl;

        :global {
            form {
                width: 100%;

                fieldset .form-group {
                    display: flex;

                    .col-sm-3 {
                        width: 160px;
                        text-align: start;
                    }

                    .col-sm-9 {
                        flex: 1;
                    }
                }
            }
        }
    }
</style>